<template>
  <div
    class="flex-grow flex-shrink w-full min-w-0 pl-0 pr-0 overflow-auto bg-white settings dark:bg-slate-800"
  >
    <setting-intro-banner :header-title="'Distribuição de leads'">
      <woot-tabs
        class="settings--tabs"
        :index="selectedTabIndex"
        :border="false"
        @change="onTabChange"
      >
        <woot-tabs-item
          v-for="tab in tabs"
          :key="tab.key"
          :name="tab.name"
          :show-badge="false"
        />
      </woot-tabs>
    </setting-intro-banner>

    <div v-if="selectedTabKey === 'lead_redistribution'">
      <lead-redistribution-config :team="team" />
    </div>
  </div>
</template>

<script>
import SettingIntroBanner from 'dashboard/components/widgets/SettingIntroBanner.vue';
import LeadRedistributionConfig from './components/LeadRedistributionConfig.vue';

export default {
  components: { SettingIntroBanner, LeadRedistributionConfig },
  data() {
    return {
      tabs: [
        {
          key: 'lead_redistribution',
          name: 'Redistribuição de leads',
        },
        // {
        //   key: 'standby',
        //   name: 'Plantões',
        // },
      ],
      selectedTabIndex: 0,
    };
  },
  computed: {
    teamId() {
      return this.$route.params.teamId;
    },
    team() {
      return this.$store.getters['teams/getTeam'](this.teamId);
    },
    selectedTabKey() {
      return this.tabs[this.selectedTabIndex]?.key;
    },
  },
  methods: {
    onTabChange(selectedTabIndex) {
      this.selectedTabIndex = selectedTabIndex;
    },
  },
};
</script>

<style lang="scss" scoped></style>
